module.exports = __webpack_public_path__ + "img/CG1_04.3b31b01.png";